// Mobile.
if (window.innerWidth <= 768) {

    // Scroll animation.
    function jumpAnnounceBar(announceActive) {
        const announceBar = document.querySelector('.usp-site-header #usp__bar' + announceActive);
        if (announceBar) {
            const scrollToAnnounceBar = announceBar.offsetLeft * announceActive;
            document.querySelector('.usp-site-header .carousel__viewport').scrollTo({
                left: scrollToAnnounceBar,
                behavior: 'smooth' // Replaces jQuery's animate function
            });
        }
    }

    let indexAnnounceBar = 1; // Set loop first number
    let announcementsTotal = document.querySelectorAll('.usp-site-header .carousel__slide').length; // Number of slides
    let announcementOne = 0; // First slide
    var delayAnnounceBar = 5000;

    function loopAnnounceBar() {
        setTimeout(function () {
            jumpAnnounceBar(announcementOne);
            indexAnnounceBar++;
            announcementOne++;

            if (announcementOne >= announcementsTotal) {
                announcementOne = 0;
            }

            if (indexAnnounceBar < (10 * announcementsTotal)) {
                loopAnnounceBar();
            }

        }, delayAnnounceBar);
    }

    loopAnnounceBar();
}
